module.exports = __webpack_public_path__ + "static/media/reports.0bfd02f4.svg";